export class PractitionerConditionsUpdate {
  practitionerId: number;
  conditionIds: number[] = [];
  conditionType: string;
}
